import { useMutation, useQueryClient, useIsMutating } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from './useOrgId.js';

const useArchiveEvent = (eventId) => {
  const queryClient = useQueryClient();
  const firebase = useFirebase();
  const orgId = useOrgId();

  const isArchiving = useIsMutating(['archiveEvent', eventId]) > 0;

  const mutation = useMutation(async ({ id = eventId }) => {
    const agent = await firebase.getAgent();
    const response = await agent.put(`/events/${encodeURIComponent(id)}/stop`);
    if (!response.ok || response.status !== 202) {
      throw new Error('Failed to archive event');
    }
  }, {
    mutationKey: ['archiveEvent', eventId],
    onSuccess: () => {
      if (!orgId) return;
      if (eventId) {
        queryClient.setQueryData(['events', eventId], (oldEvent) => {
          if (!oldEvent) return oldEvent;
          return { ...oldEvent, isArchived: true, isLive: false };
        });
      }
      return queryClient.invalidateQueries(['recentEvents', orgId]);
    },
  });
  return { ...mutation, isArchiving };
};

export default useArchiveEvent;
